module.exports = __webpack_public_path__ + "static/melbourne-distilling-58944dd1374881f144bd19f203b771ef.mp4";